import React from 'react';
import {Box} from "@wds/box";
import {Typography} from "@wds/typography";

const ConnectFAQ = (props) => {
	return (
		<Box>
			<Typography variant="sectionTitle" component="h1" weight="medium">Frequently Asked Questions</Typography>
			<Box my={5}>
				<dl>
					<dt><Typography variant="cardTitle" component="h4" weight="medium">What format should I use for timestamps?</Typography></dt>
					<dd>
						Apply Connect accepts timestamps in the <a href="https://en.wikipedia.org/wiki/ISO_8601">ISO
						8601</a> format.
					</dd>
					<dt><Typography variant="cardTitle" component="h4" weight="medium">How do I download the latest data for a report?</Typography></dt>
					<dd>
						To download the latest data you need to create a new generate report job, wait until the job
						finishes, and then download the data.
					</dd>
				</dl>
			</Box>
		</Box>
	);
};

module.exports = ConnectFAQ;
